import slugify from "slugify";

const slugifer = (text) => {
    return slugify(text, {
        lower: true
    })
}

export default slugifer;